// Generated by ReScript, PLEASE EDIT WITH CARE


var default_image_src = "https://d16heqpiqe8phi.cloudfront.net/open-graph/fb/home/porter_logo_new_cmp.jpeg";

var default_image_alt = "Porter | Mini trucks & bikes for delivery | Packers & Movers | Book and transport easily!";

export {
  default_image_src ,
  default_image_alt ,
}
/* No side effect */
